import React, {FC} from 'react';
import Link from 'next/link';

type OtherTermsProps = {
  relatedTerms: {
    url: string;
    name: string;
  }[]
}

const OtherTerms: FC<OtherTermsProps> = ({ relatedTerms }) => {
  return (
    <section className="freight-dictionary-landing__other-terms">
      <div className='container'>
        <h3 className="freight-dictionary-landing__other-terms-title">
          Related Terminologies
        </h3>
        <ul className="freight-dictionary-landing__other-terms-list">
          {relatedTerms.map(({name, url}, idx) => (
            <li key={idx} className="freight-dictionary-landing__other-terms-list-item">
              <Link href={`/freight-dictionary/${url}`}
                    className="freight-dictionary-landing__other-terms-link">
                <span>{name}</span>
                <svg
                  className="icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                  stroke="inherit"
                  fill="inherit"
                >
                  <path
                    className="line"
                    d="M2 8H8"
                    stroke="inherit"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M11 8L7 4"
                    stroke="inherit"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11 8L7 12"
                    stroke="inherit"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default OtherTerms;
